// extracted by mini-css-extract-plugin
export default {"row":"github-link_row__HVVrb","placeholder":"github-link_placeholder__Qalma","link":"github-link_link__+X0Eg"};